module.exports = __webpack_public_path__ + "static/media/info.5f576614.png";